function toggleHeaderClass() {
    if (jQuery(window).scrollTop() > 90) {
        jQuery("header .desktop-view").addClass("fix_top");
    } else {
        jQuery("header .desktop-view").removeClass("fix_top");
    }
}

// Run on scroll
jQuery(window).on("scroll", toggleHeaderClass);

// Run on page load
jQuery(document).ready(function() {
    toggleHeaderClass();
});



jQuery('.testimonial-slide').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
     {
      breakpoint: 1171,
      settings: {
          dots: true,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1
      }
     },{
        breakpoint: 1050,
        settings: {
            dots: true,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1
        }
    },{
        breakpoint: 850,
        settings: {
            dots: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1
        }
    },{
    breakpoint: 600,
    settings: {
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
    }
}]
});

$(".faq-item").click(function() {
// Toggle the answer when clicking on a question
$(this).find(".faq-answer").slideToggle(300);

// Close other answers
$(".faq-item").not(this).find(".faq-answer").slideUp(300);
});  

jQuery('.faq-list .accordion-item').click(function(){
  if( jQuery(this).hasClass('active-drop') ) {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
  } else {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
      jQuery(this).addClass('active-drop');
  }
});


jQuery(document).ready(function () {
    if (jQuery('.big_slide').length && jQuery('.min_slide_root').length) {
        initializeSliders();
    } else {
        console.error('One or both slider elements are missing!');
    }
});

function initializeSliders() {
    jQuery('.big_slide').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        touchMove: false,
        swipeToSlide: false,
        focusOnSelect: false,
        fade: false,
        autoplay: false,
        autoplaySpeed: 8000,
        asNavFor: '.min_slide_root'
    });
    jQuery('.min_slide_root').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.big_slide',
        arrows: false,
        autoplay: false,
        autoplaySpeed: 8000,
        touchMove: true,
        dots: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1281,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 835,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 481,
                settings: {
                    dots: false,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 415,
                settings: {
                    dots: false,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
}
try {
    jQuery('.big_slide').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        touchMove: false,
        swipeToSlide: false,
        focusOnSelect: false,
        autoplay: false,
        autoplaySpeed: 8000,
        fade: false,
        asNavFor: '.min_slide_root'
    });
} catch (error) {
    console.error('Error initializing .big_slide slider:', error);
}

try {
    jQuery('.min_slide_root').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.big_slide',
        arrows: false,
        autoplay: false,
        autoplaySpeed: 8000,
        touchMove: true,
        dots: false,
        focusOnSelect: true,
        responsive: [
            // Your responsive settings
        ]
    });
} catch (error) {
    console.error('Error initializing .min_slide_root slider:', error);
}



